import Call from '../../Call.v2';

const Factor = {
    get() {
        return Call(`filler/factor`);
    },

    save(factor) {
        return Call(`filler/factor`, 'POST', { factor });
    },
};

export default Factor;


// WEBPACK FOOTER //
// ./src/services/API/components/Filler/Factor.js